module.exports = [{
      plugin: require('/var/www/pixelteh3.0/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"1320375911458895"},
    },{
      plugin: require('/var/www/pixelteh3.0/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-102212018-1","head":false,"anonymize":true},
    }]
